/** Public export for the share invite row (SE-8313). */
export { default } from "./ShareInviteRowContainer";
export type { ShareInviteRowContainerProps } from "./ShareInviteRowContainer";
